export const defaultAdonisStarterQuestions = [
  {
    id: "1",
    text: "Best treatments for acne scars?",
  },
  {
    id: "2",
    text: "What can I do to reduce wrinkles quickly?",
  },
  {
    id: "3",
    text: "Best aesthetic treatments under $500?",
  },
];
